import { SessionStorageService } from "../../services/session-storage";

export function markScavenger(
  id,
  floor,
  scavengerHuntEng,
  scavengerHuntEsp,
  setScavengerHuntEng,
  setScavengerHuntEsp
) {
  // Update scavengerHuntEng
  const updatedEng = { ...scavengerHuntEng };
  const engIndex = updatedEng[floor].findIndex((item) => item.id === id);
  if (engIndex !== -1) {
    updatedEng[floor][engIndex].checked = !updatedEng[floor][engIndex].checked;
  }

  // Update scavengerHuntEsp to match scavengerHuntEng
  const updatedEsp = { ...scavengerHuntEsp };
  const espIndex = updatedEsp[floor].findIndex((item) => item.id === id);
  if (espIndex !== -1) {
    updatedEsp[floor][espIndex].checked = updatedEng[floor][engIndex].checked;
  }

  // Update context states using the provided setter functions
  setScavengerHuntEng(updatedEng);
  setScavengerHuntEsp(updatedEsp);
}

export function setScavengerHuntEng(updatedEng) {
  this.setState({ scavengerHuntEng: updatedEng }, () => {
    SessionStorageService.setValue("broad_scavengerHuntEng", updatedEng);
  });
}

export function setScavengerHuntEsp(updatedEsp) {
  this.setState({ scavengerHuntEsp: updatedEsp }, () => {
    SessionStorageService.setValue("broad_scavengerHuntEsp", updatedEsp);
  });
}